import { Controller } from 'stimulus';

export default class extends Controller {
  static get targets() {
    return ['dealerMargin', 'dealerPrice', 'retailMargin', 'retailPrice'];
  }

  initialize() {
    this.avg_cost = this.element.querySelector('[name="max_cost_price"]').value;
    this.default_margin_for_retail = parseFloat(window.document.getElementById('brand_margin_for_retail').innerText);
    this.multiplier = 1 + (this.default_margin_for_retail / 100);
  }

  connect() {
    this.dealerMarginTarget.addEventListener('keyup', () => this.calcByDealerMargin());
    this.dealerPriceTarget.addEventListener('keyup', () => this.calcByDealerPrice());
    this.retailMarginTarget.addEventListener('keyup', () => this.calcByRetailMargin());
    this.retailPriceTarget.addEventListener('keyup', () => this.calcByRetailPrice());
  }

  calcByDealerMargin() {
    if (!this.avg_cost || this.avg_cost === 0) { return }

    this.dealerPriceTarget.value = Math.ceil(this.avg_cost * (1 + this.dealerMarginTarget.value / 100));
    this.retailPriceTarget.value = Math.ceil(this.dealerPriceTarget.value * this.multiplier);
    this.retailMarginTarget.value = ((this.retailPriceTarget.value / this.avg_cost - 1) * 100).toFixed(2);
  }

  calcByDealerPrice() {
    this.retailPriceTarget.value = Math.ceil(this.dealerPriceTarget.value * this.multiplier);

    if (this.avg_cost && this.avg_cost > 0) {
      this.dealerMarginTarget.value = ((this.dealerPriceTarget.value / this.avg_cost - 1) * 100).toFixed(2);
      this.retailMarginTarget.value = ((this.retailPriceTarget.value / this.avg_cost - 1) * 100).toFixed(2);
    }
  }

  calcByRetailMargin() {
    if (!this.avg_cost || this.avg_cost === 0) { return }

    this.retailPriceTarget.value = Math.ceil(this.avg_cost * (1 + this.retailMarginTarget.value / 100));
  }

  calcByRetailPrice() {
    if (!this.avg_cost || this.avg_cost === 0) { return }

    this.retailMarginTarget.value = ((this.retailPriceTarget.value / this.avg_cost - 1) * 100).toFixed(2);
  }
}
